import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Debugger = _resolveComponent("Debugger");
    const _component_router_view = _resolveComponent("router-view");
    const _component_v_overlay = _resolveComponent("v-overlay");
    const _component_Spinner = _resolveComponent("Spinner");
    const _component_app_version = _resolveComponent("app-version");
    const _component_v_main = _resolveComponent("v-main");
    const _component_GlobalSnackbar = _resolveComponent("GlobalSnackbar");
    const _component_Alert = _resolveComponent("Alert");
    const _component_v_app = _resolveComponent("v-app");
    return (_openBlock(), _createBlock(_component_v_app, null, {
        default: _withCtx(() => [
            _createCommentVNode(" debugger! "),
            (_ctx.$brgGlobal.VUE_APP_ENV !== 'production')
                ? (_openBlock(), _createBlock(_component_Debugger, { key: 0 }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" <NavigationDrawer\n      v-model=\"drawer\"\n    ></NavigationDrawer> "),
            _createCommentVNode(" <AppBar\n      v-if=\"requiresAppBar\"\n      @toggle-drawer=\"drawer = !drawer\"\n    >\n    </AppBar> "),
            _createVNode(_component_v_main, null, {
                default: _withCtx(() => [
                    _createCommentVNode(" Router 1 Depth "),
                    _createVNode(_component_router_view),
                    _createVNode(_component_v_overlay, {
                        value: _ctx.isOverlay,
                        absolute: "",
                        opacity: "0.6",
                        "z-index": "99"
                    }, null, 8 /* PROPS */, ["value"]),
                    _createVNode(_component_Spinner),
                    _createVNode(_component_app_version)
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" <BottomNavigation v-if=\"requiresBottomNavigation\">\n    </BottomNavigation> "),
            _createCommentVNode(" 글로벌 스낵바 "),
            _createVNode(_component_GlobalSnackbar),
            _createCommentVNode(" 글로벌 컨펌 "),
            _createVNode(_component_Alert)
        ]),
        _: 1 /* STABLE */
    }));
}
